import React, {useEffect} from "react";
import {Section, RowFooter, SubtitleFooter, ColFooter, SimpleText, SubtitleLink} from "./styles";
import {isMobile} from "../../constants/Helpers";
import {useLocation} from "react-router-dom";

export default function InfoSection() {
   let location = useLocation();

   useEffect(() => {
      console.log();
   }, []);

   return (
      <Section>
         <RowFooter>
            <ColFooter>
               <SubtitleFooter>Dirección</SubtitleFooter>
               <SimpleText>Avenida Presidente Masaryk 275, Colonia Polanco. 11550. CDMX</SimpleText>
            </ColFooter>
            <ColFooter>
               <SubtitleFooter>Mail de contacto</SubtitleFooter>
               <SimpleText>domecqacademy@pedrodomecq.com</SimpleText>
            </ColFooter>
            <ColFooter>
               <SubtitleFooter>Teléfono</SubtitleFooter>
               <SimpleText>(55) 6819-2323</SimpleText>
            </ColFooter>
         </RowFooter>
         <RowFooter className="second">
            {isMobile ? (
               <div className="mobileFlex">
                  <ColFooter className="min">
                     {/* <a href="?privacy=true">sadsa</a> */}
                     <SubtitleLink to={`${location.pathname}?privacy=true`}>Aviso de privacidad</SubtitleLink>
                  </ColFooter>
                  <ColFooter className="min">
                     <SubtitleFooter>Términos y condiciones</SubtitleFooter>
                  </ColFooter>
               </div>
            ) : (
               <>
                  <ColFooter>
                     <SubtitleLink to={`${location.pathname}?privacy=true`}>Aviso de privacidad</SubtitleLink>
                  </ColFooter>
                  <ColFooter>
                     <SubtitleLink to={`${location.pathname}?terms=true`}>Términos y condiciones</SubtitleLink>
                  </ColFooter>
               </>
            )}
            <ColFooter>
               <SimpleText>&copy; CASA PEDRO DOMECQ 2020</SimpleText>
            </ColFooter>
         </RowFooter>
      </Section>
   );
}
